export const ASSISTANT_NAME = 'Maya'
export const ASSISTANT_ROLE = 'AI booking assistant'
export const ASSISTANT_TAGLINE = 'Smart, fast, helpful'
export const DEFAULT_ASSISTANT_AVATAR = 'https://kleknnxdnspllqliaong.supabase.co/storage/v1/object/public/handle/maya.png'
